import { ReactComponent as ShowSvg } from '../icons/show.svg'
import { MonitorObject } from '@/global/interface/monitor-object/monitor-object'
import classNames from 'classnames'
import { useContext, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router'
import MonitorParameterItem from './param-item'
import { CommonTabbarState } from '@/global/components/common-tabbar'
import { CommonTabbarContext } from '@/App'
import { TAB_TYPE } from '@/enums/tab-type'
import { emitter } from '@/global/listeners'
import { Emit_Event } from '@/enums/emit-event'

interface Iprops {
    monitorObject: MonitorObject // 监测对象
    active: boolean, // 是否激活
    activedParamId: number, // 激活的参数id
}

export default function MonitorObjectWithParamsItem(props: Iprops) {
    const { monitorObject, active, activedParamId } = props
    const [item, setItem] = useState<MonitorObject>();
    const itemRef = useRef(item);
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext); // tabbar上下文

    useEffect(() => {
        setItem(monitorObject);
        return (() => {
            emitter.off(Emit_Event.UPDATE_MONITOR_OBJECT, onUpdateMonitorObjectFinish);
        })
    }, [monitorObject])

    useEffect(() => {
        itemRef.current = item
    }, [item])

    // 点击了展开收起监测对象
    const handleExpandItem = () => {
        setItem({ ...item, expanded: !item.expanded });
    }

    // 打开监测对象详情
    const openMonitorObjectDetail = (e) => {
        e.stopPropagation();
        commonTabbarContext.navigate(`${TAB_TYPE.MONITOR_OBJECT}/${item.id}`)
        // 监听更新监测对象的信号
        emitter.on(Emit_Event.UPDATE_MONITOR_OBJECT, onUpdateMonitorObjectFinish);
    }

    // 更新了监测对象的详情
    const onUpdateMonitorObjectFinish = (result: MonitorObject) => {
        if (result?.id != item.id) return;
        setItem({ ...itemRef.current, ...result, expanded: true });
    }

    if (!item) {
        return (<div></div>)
    }
    return (
        <div className="monitor-object-item">
            <div className={classNames({
                "title": true,
                "selected": active,
            })} onClick={handleExpandItem}>
                <div className="name">
                    {item.name}
                    <ShowSvg className={classNames({
                        "arrow-icon": true,
                        "expanded": item.expanded
                    })} />
                </div>
                <div className="detail-btn" onClick={(e) => openMonitorObjectDetail(e)}><div className="text">详情</div></div>
            </div>
            {item.expanded && (
                <div className="param-list">
                    {(item.rootMonitorParameters || []).map((param, idx) => (
                        <MonitorParameterItem key={idx} monitorParameter={param} activedParamId={activedParamId} onUpdateParam={(id, data) => {
                            let newParam = { ...param, ...data };
                            item.rootMonitorParameters.splice(idx, 1, newParam);
                            setItem({ ...item });
                        }} />
                    ))}

                </div>
            )}
        </div>
    )
}